import api from '../../redux/api';

// CD-8: single canonical seller tiers endpoint. The legacy `/v1/seller/tiers/customer-tiers`
// mount is a deprecated alias on the backend; frontend uses the canonical path only.
const BASE_URL = '/v1/seller/customers/tiers';

export const sellerCustomerTiersService = {
  /**
   * Get customer tiers for seller
   * Returns tiers based on global setting (account tiers + own tiers if global OFF)
   */
  getTiers: async () => {
    const response = await api.get(`${BASE_URL}/list`);
    return response.data;
  },

  /**
   * Create a new customer tier (only when global settings OFF)
   */
  createTier: async (tierData) => {
    const response = await api.post(BASE_URL, tierData);
    return response.data;
  },

  /**
   * Update an existing customer tier (only own tiers, only when global OFF)
   */
  updateTier: async (tierId, tierData) => {
    const response = await api.put(`${BASE_URL}/${tierId}`, tierData);
    return response.data;
  },

  /**
   * Delete a customer tier (only own tiers, only when global OFF)
   */
  deleteTier: async (tierId) => {
    const response = await api.delete(`${BASE_URL}/${tierId}`);
    return response.data;
  },

  /**
   * Toggle tier active status (only own tiers, only when global OFF)
   */
  toggleTierStatus: async (tierId) => {
    const response = await api.patch(`${BASE_URL}/${tierId}/toggle-status`);
    return response.data;
  }
};

export default sellerCustomerTiersService;
